<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <div class="button-header">
        <button type="button" *ngIf="!close" aria-label="voltar" [id]="id" (click)="back($event)">
          <img aria-hidden="true" [src]="icon" alt="icon">
        </button>
        <ion-label *ngIf="title" (click)="clickLabel()" [ngClass]="{'flex-1' : start || end}">
          <h1>{{title}}</h1>
        </ion-label>
        <ion-label class="stage" [ngClass]="{'stageNot': start === 'false'}" *ngIf="start">
          <span role="text" attr.aria-label="passo {{start}} de {{end}}">{{start}} de {{end}}</span>
        </ion-label>
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>